import {
  getColorsByPath,
  responsive,
  spacing,
  ThemeUICSSObject,
} from '@apia/theme';

export const gridSpan = responsive({
  0: 'span 1',
  3: 'span 2',
  4: 'span 4',
});

export const upsertion: ThemeUICSSObject = {
  fieldset: {
    display: 'grid',
    gridTemplateColumns: responsive({
      0: '1fr',
      2: 'repeat(2, 1fr)',
      4: 'repeat(4, 1fr)',
    }),
    gap: spacing(4),
    p: spacing(7),
    border: 'none',
    ...getColorsByPath('tab'),

    '.checkbox': {
      display: 'flex',
      flexDirection: 'row-reverse',
      alignItems: 'center',
      justifyContent: 'start',
      gap: spacing(4),
      gridColumn: gridSpan,
    },

    span: {
      m: spacing(0),
      fontWeight: 'normal',
    },

    '.textarea': {
      gridColumn: gridSpan,

      textarea: {
        height: '15vh',
        mt: spacing(1),
      },
    },

    '.span-2': {
      gridColumn: 'span 2',
    },

    '& label': {
      display: 'block',
    },

    '.fieldLabel__container': {
      fontWeight: 'bold',
    },
  },
};
